import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import mAxiosApi from "@/api";
import OidcService from "@/core/services/OidcService";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:codeArk?",
    redirect: to => ({
      path: '/sign-in/'+to.params.codeArk,
  }),
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in/:codeArk?",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/signaturesToken",
        name: "signaturesToken",
        component: () => import("@/views/still/bord/signatures.vue"),
      },
      {
        path: "/sign-in/:codeArk/:redirect/:token?",
        name: "sign-in-redirect",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
      {
        path: "/password/:token",
        name: "password",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/ChangePassword.vue"),
      },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/signatureToken",
    name: "signatureToken",
    component: () => import("@/views/still/signaturesToken.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    path: "/loader/:redirect/:token?",
    name: "loader",
    component: () => import("@/views/Loader.vue"),
  },
 
  {
    path: "/",
    redirect: "/board",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/board",
        name: "board",
        redirect: "/board/overview",
        component: () => import("@/views/still/deploy/deploy.vue"),
        children: [
          {
            path: "overview",
            name: "overview",
            component: () => import("@/views/still/deploy/overview.vue"),
          },
          {
            path: "overview/:status",
            name: "overviewStatus",
            component: () => import("@/views/still/deploy/overview.vue"),
          },
        ],
      },
      {
        path: "/profil",
        name: "profil",
        component: () => import("@/views/still/Profil.vue"),
      },
      
      {
        path: "/bord",
        name: "bord",
        redirect: "/bord/articles",
        component: () => import("@/views/still/bord/deploy.vue"),
        children: [
          {
            path: "articles",
            name: "articles",
            component: () => import("@/views/still/bord/articles.vue"),
          },
          {
            path: "description",
            name: "description",
            component: () => import("@/views/still/bord/description.vue"),
          },
          {
            path: "identification",
            name: "identification",
            component: () => import("@/views/still/bord/identification.vue"),
          },
          {
            path: "signatures",
            name: "signatures",
            component: () => import("@/views/still/bord/signatures.vue"),
          },
        ],
      },
      {
        path: "/admin",
        name: "admin",
        component: () => import("@/views/still/admin/admin.vue"),
      },
      {
        path: "/importProd",
        name: "importProd",
        component: () => import("@/views/still/ImportProd.vue"),
      },
      {
        path: "/parametrage",
        name: "parametrage",
        component: () => import("@/views/still/parametrage.vue"),
      },
    ],
  },

];


const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const publicRoutes = [
  "sign-in",
  "sign-in-redirect",
  "sign-up",
  "password-reset",
  "password",
  "signaturesToken",
  "signatureToken",
  "loader",
  "404",
  "500",
];

router.beforeEach(async (to, from, next) => {
  store.commit(Mutations.RESET_LAYOUT_CONFIG);
  setTimeout(() => { window.scrollTo(0, 0); }, 100);

  // Public routes: no auth check needed
  if (publicRoutes.includes(to.name as string)) {
    next();
    return;
  }

  // Check if authenticated (OIDC or classic session)
  const isOidc = await OidcService.isAuthenticated();
  const hasClassicToken = !!JwtService.getToken();

  if (!isOidc && !hasClassicToken) {
    next({ name: "sign-in" });
    return;
  }

  // Hydrate store if not yet done
  if (!store.getters.isUserAuthenticated) {
    await store.dispatch(Actions.VERIFY_AUTH);
  }

  next();
});

export default router;


export async function getAxios(request: string): Promise<any> {
  const response = await mAxiosApi.get(request);
  // console.log(response.data);
  return response.data;
}